import { gql } from '@apollo/client';

export const STAFF_FIELDS = gql`
  fragment StaffFields on Staff {
    staffId
    staffNumber
    firstName
    lastName
    email
    salary
    phone1
    phone2
    uid
    managerId
    registrationNumber
    status
  }
`;
